import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "#000",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 120 120"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M.93.93h117.235v117.235H.929z" }, null, -1),
    _createElementVNode("path", {
      "stroke-linejoin": "miter",
      d: "M117.957 1.039 1.27 117.823"
    }, null, -1)
  ])))
}
export default { render: render }